module.exports = __webpack_public_path__ + "static/media/House-Keeping-Required.5088e673.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/housekeeping/House-Keeping-Required.png
// module id = 106
// module chunks = 0